import { createRoot } from "react-dom/client";
import { CookiesProvider } from "react-cookie";
import { Provider } from 'react-redux'

import store from './main/config/store'
import { App } from './presentation/components/app/App';

import { StrictMode } from "react";
import { ErudaProvider } from "./Eruda";
import { Background } from "./presentation/components/FormControls/Background";


createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <CookiesProvider>
      <Background>
        {/* <ErudaProvider> */}
        <App />
        {/* </ErudaProvider> */}
      </Background>
    </CookiesProvider>
  </Provider>
);